import React from 'react'
import { Grid, Box, OutlinedInput } from '@mui/material'
import { PartialShoesAction, Personal } from 'src/types'
import { useDebounce } from 'use-debounce'
import Select from 'react-select'
import { UseFormRegister } from 'react-hook-form'
import { useLocale } from 'src/locales/useLocale'
export const SET_PERSONAL = 'setPersonal'

type Props = {
  isDisabled: boolean
  duplicationPosition?: boolean
  existEmoji: boolean
  dispatch: React.Dispatch<PartialShoesAction>
  register: UseFormRegister<{ mailAddress: string; mailAddress2: string }>
}

export const ShoesConsumerForm: React.FC<Props> = ({ isDisabled, duplicationPosition, existEmoji, dispatch, register }) => {
  const [personalData, setPersonalData] = React.useState<Personal>()
  const personal = useDebounce(personalData, 500)
  const { t } = useLocale()
  React.useEffect(() => {
    dispatch({ type: SET_PERSONAL, personal: personal[0] })
  }, [personal[0]])

  return (
    <Grid container>
      <Grid item xs={12}>
        <Box pt={2} mr={1} display={'flex'} alignItems={'center'}>
          <Box fontWeight="bold" fontSize="16px" mb={1}>
            {t.CUSTOMER_INFORMATION}
          </Box>
        </Box>
        {existEmoji && <Box color={'red'}>絵文字を刺繍内容から排除してください。</Box>}
        {isDisabled && <Box color={'red'}>{t.CUSTOMER_INFORMATION_CAUTION}</Box>}
        {duplicationPosition && <Box color={'red'}>{t.DUPLICATE_EMBROIDERY_POSITION_CAUTION}</Box>}
        <Grid container>
          <Grid item xs={12} sm={12}>
            <Box p={1}>
              <Box>{t.LEAGUE}</Box>
              <Select
                options={t.LEAGUE_OPTIONS}
                styles={{ menu: (provided) => ({ ...provided, zIndex: 9999 }) }}
                isDisabled={isDisabled}
                isSearchable={false}
                menuPlacement={'top'}
                onChange={(value) => setPersonalData({ ...personalData, league: value.label })}
              />
            </Box>
          </Grid>
          <Grid item xs={12} sm={6}>
            <Box p={1}>
              <Box>{t.EMAIL_ADDRESS}</Box>
              <Box pb={1} display={'flex'} alignItems={'center'}>
                <OutlinedInput type={'email'} autoComplete={'off'} fullWidth {...register('mailAddress')} disabled={isDisabled} />
              </Box>
            </Box>
          </Grid>
          <Grid item xs={12} sm={6}>
            <Box p={1}>
              <Box>{t.EMAIL_ADDRESS_RETYPE}</Box>
              <Box pb={1} display={'flex'} alignItems={'center'}>
                <OutlinedInput type={'email'} autoComplete={'off'} fullWidth {...register('mailAddress2')} disabled={isDisabled} />
              </Box>
            </Box>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  )
}
